import axios from 'axios';
import CryptoJS from 'crypto-js';

/* eslint-disable */
const api_url_emclite = 'jcrn-api-server.eilis-ai.com/api/v1';


const apikey = '175e0506314052a7d2a45ae20f6b0d257720b5f5';
const key = 'XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv2';
const iv = 'N6lRbzhhbyHgiU68';

const keyStr = CryptoJS.enc.Utf8.parse(key);
const ivStr = CryptoJS.enc.Utf8.parse(iv);

const options = {
    iv: ivStr,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
};



const state = {
    user: null,
    config: {},
    route: '',
    shopList: {},
    levelList: {}
}

const getters = {
    user: state => state.user,
    config: state => state.config,
    route: state => state.route,
    shopList: state => state.shopList,
    levelList: state => state.levelList
}

const mutations = {
    RECEIVE_USER(state, payload) {
        state.user = payload;
    },
    RECEIVE_CONFIG(state, payload) {
        state.config[payload.auth] = payload;
    },
    CHANGE_ROUTE(state, payload) {
        state.route = payload;
    },
    SET_SHOPS(state, payload) {
        state.shopList[payload.auth] = payload.list;
    },
    SET_LEVELS(state, payload) {
        state.levelList[payload.auth] = payload.list;
    }
}


function sendRequest(url, contents) {
    const apiUrl = `https://${api_url_emclite}/${url}`;
    const signature = CryptoJS.AES.encrypt(JSON.stringify(contents), keyStr, options).toString();
    const data = {
        content: signature
    };
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'api-key': apikey,
        }
    }
    return axios.post(apiUrl, data, config)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}


// 測試更新
const actions = {
    changePageRoute({ commit, state }, contents) {
        commit('CHANGE_ROUTE', contents);
    },
    getRegConfig({ commit, state }, contents) {
        const url = 'getRegConfigs';
        return sendRequest(url, contents)
            .then((res) => {
                return res;
            })
    },
    setRegConfig({ commit, state }, contents) {
        const url = 'setRegConfig';
        return sendRequest(url, contents)
            .then((res) => {
                return res;
            })
    },
    deleteRegConfigs({ commit, state }, contents) {
        const url = 'deleteRegConfigs';
        return sendRequest(url, contents)
            .then((res) => {
                return res;
            })
    },
    updateRegConfig({ commit, state }, contents) {
        const url = 'updateRegConfig';
        return sendRequest(url, contents)
            .then((res) => {
                return res;
            })
    },
    updateConfig({ commit, state }, contents) {
        const apiUrl = `https://${api_url_emclite}/updateConfig`;
        const signature = CryptoJS.AES.encrypt(JSON.stringify(contents), keyStr, options).toString();
        const data = {
            content: signature
        };
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'api-key': apikey,
            }
        }
        return axios.post(apiUrl, data, config)
            .then((res) => {
                commit('RECEIVE_CONFIG', contents.config);
                return res.data;
            })
    },
    getConfig({ commit, state }, contents) {
        const apiUrl = `https://${api_url_emclite}/getConfig`;
        const signature = CryptoJS.AES.encrypt(JSON.stringify(contents), keyStr, options).toString();
        const data = {
            content: signature
        };
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'api-key': apikey,
            }
        }
        return axios.post(apiUrl, data, config)
            .then((res) => {
                commit('RECEIVE_CONFIG', res.data.result);
                return res.data;
            })
    },
    enableAccount({ commit, state }, contents) {
        const apiUrl = `https://${api_url_emclite}/enableClient`;
        const signature = CryptoJS.AES.encrypt(JSON.stringify(contents), keyStr, options).toString();
        const data = {
            content: signature
        };
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'api-key': apikey,
            }
        }
        return axios.post(apiUrl, data, config)
            .then((res) => {
                return res.data;
            })
    },
    updateShop({ commit, state }, contents) {
        const url = 'updateShop';
        return sendRequest(url, contents)
            .then((res) => {
                return res;
            })
    }, 
    deleteShop({ commit, state }, contents) {
        const url = 'deleteShop';
        return sendRequest(url, contents)
            .then((res) => {
                return res;
            })
    },
    sendSMS({ commit, state }, contents) {
        const apiUrl = 'https://louisa-api-server.eilis-ai.com/sendSMS';
        const data = {
            phone: contents.phone, // 起始交易日期
            message: `你的今日實聯制驗證碼為: ${contents.code} (Powered by EILIS)`,
            service: contents.service,
            auth: contents.auth,
            countryCode: '886'
        };
        return axios.post(apiUrl, data)
            .then((res) => {
                return res;
            })
    },
    getShops({ commit, state }, contents) {
        const url = 'getShops';
        return sendRequest(url, contents)
            .then((res) => {
                const data = {
                    list: res.result,
                    auth: contents.auth
                };
                commit('SET_SHOPS', data);
                return res;
            })
    }
}

export default {
    namespaced: true,
    state, getters, mutations, actions
}